<section grid="columns" horizontally-distributed="equal">

  <div class="section">-</div>

  <div class="section">-</div>

</section>

